import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Home, Check, Euro, Thermometer, TrendingUp } from 'lucide-react';

const SolutionIsolation = () => {
  return (
    <div style={{ background: 'var(--bg-page)', minHeight: '100vh' }}>
      {/* Hero */}
      <section style={{ paddingTop: '140px', paddingBottom: '64px', background: 'var(--bg-card)' }}>
        <div className="container">
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '48px', alignItems: 'center' }}>
            <div>
              <div style={{ width: '64px', height: '64px', borderRadius: '50%', background: 'var(--brand-primary)', display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: '24px' }}>
                <Home size={32} style={{ color: 'var(--brand-dark)' }} />
              </div>
              <h1 className="display-medium" style={{ color: 'var(--text-primary)', marginBottom: '24px' }}>
                Isolation Thermique Performante
              </h1>
              <p className="body-large" style={{ color: 'var(--text-secondary)', marginBottom: '32px' }}>
                Isolation des murs, combles et planchers. Gagnez jusqu'à +3°C en hiver et -3°C en été pour un confort optimal toute l'année.
              </p>
              <div style={{ display: 'flex', gap: '16px', flexWrap: 'wrap' }}>
                <Link to="/devis" className="btn-primary" style={{ display: 'inline-flex', alignItems: 'center', gap: '8px' }}>
                  Demander un devis gratuit
                  <ArrowRight size={20} />
                </Link>
                <a href="tel:0175438580" className="btn-secondary">
                  01 75 43 85 80
                </a>
              </div>
            </div>
            <div>
              <img src="https://images.unsplash.com/photo-1621157281974-e926449624e3" alt="Isolation thermique" style={{ width: '100%', borderRadius: '32px' }} />
            </div>
          </div>
        </div>
      </section>

      {/* Avantages */}
      <section className="pad-giant">
        <div className="container">
          <h2 className="heading-1" style={{ textAlign: 'center', marginBottom: '48px', color: 'var(--text-primary)' }}>
            Les Bénéfices d'une Bonne Isolation
          </h2>
          <div className="network-grid">
            <div className="network-card">
              <Euro size={32} style={{ color: 'var(--brand-primary)', marginBottom: '16px' }} />
              <h3 className="network-card-title">Jusqu'à 30% d'Économies</h3>
              <p className="network-card-content">
                Réduisez significativement vos dépenses de chauffage et climatisation.
              </p>
            </div>
            <div className="network-card">
              <Thermometer size={32} style={{ color: 'var(--brand-primary)', marginBottom: '16px' }} />
              <h3 className="network-card-title">Confort Été & Hiver</h3>
              <p className="network-card-content">
                +3°C l'hiver, -3°C l'été. Température stable toute l'année.
              </p>
            </div>
            <div className="network-card">
              <TrendingUp size={32} style={{ color: 'var(--brand-primary)', marginBottom: '16px' }} />
              <h3 className="network-card-title">Valorisation du Bien</h3>
              <p className="network-card-content">
                Améliorez le DPE de votre logement et augmentez sa valeur immobilière.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Types d'isolation */}
      <section className="pad-giant" style={{ background: 'var(--bg-card)' }}>
        <div className="container">
          <h2 className="heading-1" style={{ textAlign: 'center', marginBottom: '48px', color: 'var(--text-primary)' }}>
            Nos Solutions d'Isolation
          </h2>
          <div className="network-grid">
            <div className="network-card">
              <h3 className="network-card-title">Isolation des Combles</h3>
              <p className="network-card-content">
                30% des déperditions thermiques passent par le toit. Solution prioritaire et très rentable.
              </p>
              <ul style={{ listStyle: 'none', padding: 0, marginTop: '16px' }}>
                <li style={{ display: 'flex', gap: '8px', marginBottom: '8px', fontSize: '14px' }}>
                  <Check size={16} style={{ color: 'var(--brand-primary)', marginTop: '2px' }} />
                  <span>Combles perdus : soufflage laine</span>
                </li>
                <li style={{ display: 'flex', gap: '8px', marginBottom: '8px', fontSize: '14px' }}>
                  <Check size={16} style={{ color: 'var(--brand-primary)', marginTop: '2px' }} />
                  <span>Combles aménageables : panneaux</span>
                </li>
                <li style={{ display: 'flex', gap: '8px', fontSize: '14px' }}>
                  <Check size={16} style={{ color: 'var(--brand-primary)', marginTop: '2px' }} />
                  <span>Installation en 1 jour</span>
                </li>
              </ul>
            </div>
            <div className="network-card">
              <h3 className="network-card-title">Isolation des Murs (ITE)</h3>
              <p className="network-card-content">
                Isolation par l'extérieur : performance maximale sans perdre de surface habitable.
              </p>
              <ul style={{ listStyle: 'none', padding: 0, marginTop: '16px' }}>
                <li style={{ display: 'flex', gap: '8px', marginBottom: '8px', fontSize: '14px' }}>
                  <Check size={16} style={{ color: 'var(--brand-primary)', marginTop: '2px' }} />
                  <span>Aucune perte de surface</span>
                </li>
                <li style={{ display: 'flex', gap: '8px', marginBottom: '8px', fontSize: '14px' }}>
                  <Check size={16} style={{ color: 'var(--brand-primary)', marginTop: '2px' }} />
                  <span>Ravalement inclus</span>
                </li>
                <li style={{ display: 'flex', gap: '8px', fontSize: '14px' }}>
                  <Check size={16} style={{ color: 'var(--brand-primary)', marginTop: '2px' }} />
                  <span>Performance thermique maximale</span>
                </li>
              </ul>
            </div>
            <div className="network-card">
              <h3 className="network-card-title">Isolation des Planchers</h3>
              <p className="network-card-content">
                Isolation sous-sol, vide sanitaire ou garage pour supprimer les sols froids.
              </p>
              <ul style={{ listStyle: 'none', padding: 0, marginTop: '16px' }}>
                <li style={{ display: 'flex', gap: '8px', marginBottom: '8px', fontSize: '14px' }}>
                  <Check size={16} style={{ color: 'var(--brand-primary)', marginTop: '2px' }} />
                  <span>Suppression sol froid</span>
                </li>
                <li style={{ display: 'flex', gap: '8px', marginBottom: '8px', fontSize: '14px' }}>
                  <Check size={16} style={{ color: 'var(--brand-primary)', marginTop: '2px' }} />
                  <span>Gain de confort immédiat</span>
                </li>
                <li style={{ display: 'flex', gap: '8px', fontSize: '14px' }}>
                  <Check size={16} style={{ color: 'var(--brand-primary)', marginTop: '2px' }} />
                  <span>Travaux propres et rapides</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* Aides */}
      <section className="pad-giant">
        <div className="container">
          <h2 className="heading-1" style={{ textAlign: 'center', marginBottom: '24px', color: 'var(--text-primary)' }}>
            Aides Financières Disponibles
          </h2>
          <p className="body-large" style={{ textAlign: 'center', color: 'var(--text-secondary)', maxWidth: '700px', margin: '0 auto 48px' }}>
            L'isolation est le poste le mieux financé par les aides de l'État
          </p>
          <div style={{ maxWidth: '800px', margin: '0 auto' }}>
            <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
              {[
                'MaPrimeRénov\' jusqu\'à 7 000€ (ITE)',
                'Prime CEE jusqu\'à 20€/m² isolé',
                'TVA réduite à 5.5%',
                'Éco-PTZ : prêt à taux zéro jusqu\'à 50 000€',
              ].map((item, index) => (
                <li key={index} style={{ display: 'flex', alignItems: 'center', gap: '16px', padding: '16px', background: index % 2 === 0 ? 'var(--bg-card)' : 'transparent', borderRadius: '12px', marginBottom: '8px' }}>
                  <Check size={24} style={{ color: 'var(--brand-primary)', flexShrink: 0 }} />
                  <span style={{ fontSize: '18px', color: 'var(--text-secondary)' }}>{item}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="pad-giant" style={{ background: 'var(--brand-dark)', textAlign: 'center' }}>
        <div className="container">
          <h2 className="heading-1" style={{ color: 'white', marginBottom: '24px' }}>
            Isolez Votre Logement Maintenant
          </h2>
          <p className="body-large" style={{ color: 'white', opacity: 0.9, maxWidth: '700px', margin: '0 auto 48px' }}>
            Profitez des aides de l'État pour isoler votre maison à moindre coût
          </p>
          <Link to="/devis" className="btn-cta" style={{ background: 'var(--brand-primary)', color: 'var(--brand-dark)' }}>
            Demander mon devis gratuit
          </Link>
        </div>
      </section>
    </div>
  );
};

export default SolutionIsolation;
